import { createDispatchFunction } from 'shared/helpers';
import partial from 'lodash/partial';
import NotificationsService from './NotificationsService';
import { NOTIFICATION_STATUS } from 'shared/constants';

// Actions
const GET_ALL_NOTIFICATIONS = 'notifications/GET_ALL_NOTIFICATIONS';
const GET_NOT_VIEWED_NOTIFICATIONS = 'notifications/GET_NOT_VIEWED_NOTIFICATIONS';
const GET_NOT_VIEWED_NOTIFICATIONS_COUNT = 'notifications/GET_NOT_VIEWED_NOTIFICATIONS_COUNT';
const GET_VIEWED_NOTIFICATIONS_COUNT = 'notifications/GET_VIEWED_NOTIFICATIONS_COUNT';
const ADD_NOTIFICATION = 'notifications/ADD_NOTIFICATION';
const SET_NOTIFICATION_AS_READ = 'notifications/SET_NOTIFICATION_AS_READ';
const SET_USER_PREFERENCES = 'notifications/SET_USER_PREFERENCES';
const GET_TEMPLATEPARAMS = 'notifications/GET_TEMPLATEPARAMS';
const CLEAR_NOTIFICATIONS = 'notifications/CLEAR_NOTIFICATIONS';

const initialState = {
  notifications: [],
  notViewedNotifications: [],
  notViewedNotificationsCount: null,
  viewedNotificationsCount: null,
  loadingNotifications: false,
  loadingNotViewed: false,
  loadingNotViewedCount: false,
  noMoreNotifications: false,
  tempalteparams: [],
  errorNotifications: {},
};

// Reducer
export default function notificationsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.result.data ? state.notifications.concat(action.result.data) : state.notifications,
        errorNotifications: action.result.error,
        noMoreNotifications: action.result.data ? !action.result.data.length : false,
        loadingNotifications: action.result.loading,
      };
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: [],
      };
    case GET_NOT_VIEWED_NOTIFICATIONS:
      return {
        ...state,
        notViewedNotifications: action.result.data || state.notViewedNotifications || [],
        loadingNotViewed: action.result.loading || false,
      };
    case GET_NOT_VIEWED_NOTIFICATIONS_COUNT:
      return {
        ...state,
        notViewedNotificationsCount: action.result.data ? action.result.data.count : state.notViewedNotificationsCount || null,
        loadingNotViewedCount: action.result.loading,
      };
    case GET_VIEWED_NOTIFICATIONS_COUNT:
      return {
        ...state,
        viewedNotificationsCount: action.result.data ? action.result.data.count : state.viewedNotificationsCount || null,
        loadingViewedCount: action.result.loading,
      };
    case ADD_NOTIFICATION :
      return {
        ...state,
      };
    case SET_NOTIFICATION_AS_READ :
      return {
        ...state,
      };
    case SET_USER_PREFERENCES:
      return {
        ...state,
        userpreferences: action.result.data,
      };
    case GET_TEMPLATEPARAMS:
      return {
        ...state,
        tempalteparams: action.result.data,
      };

    default:
      return state;
  }
}

// Action Creators
export function getAllNotificationsAction(result) {
  return { type: GET_ALL_NOTIFICATIONS, result };
}

export function clearNotificationsAction() {
  return { type: CLEAR_NOTIFICATIONS };
}

export function getNotViewedNotificationsAction(result) {
  return { type: GET_NOT_VIEWED_NOTIFICATIONS, result };
}

export function getNotViewedNotificationsCountAction(result) {
  return { type: GET_NOT_VIEWED_NOTIFICATIONS_COUNT, result };
}

export function getViewedNotificationsCountAction(result) {
  return { type: GET_VIEWED_NOTIFICATIONS_COUNT, result };
}

export function addNotificationAction(result) {
  return { type: ADD_NOTIFICATION, result };
}

export function setNotificationAsReadAction(result) {
  return { type: SET_NOTIFICATION_AS_READ, result };
}

export function setUserPreferencesAction(result) {
  return { type: SET_USER_PREFERENCES, result };
}

export function getTemplateparamsAction(result) {
  return { type: GET_TEMPLATEPARAMS, result };
}


// Action dispatcher functions
export function getAllNotifications(userId, params) {
  return createDispatchFunction(
    partial(NotificationsService.getNotifications, userId, params),
    getAllNotificationsAction
  );
}

export function getNotViewedNotifications(userId) {
  return createDispatchFunction(
    partial(NotificationsService.getNotifications, userId, { status:NOTIFICATION_STATUS.notViewed }),
    getNotViewedNotificationsAction
  );
}

export function getNotViewedNotificationsCount(userId) {
  return createDispatchFunction(
    partial(NotificationsService.getNotificationsCount, userId, NOTIFICATION_STATUS.notViewed),
    getNotViewedNotificationsCountAction
  );
}

export function getViewedNotificationsCount(userId) {
  return createDispatchFunction(
    partial(NotificationsService.getNotificationsCount, userId, NOTIFICATION_STATUS.viewed),
    getViewedNotificationsCountAction
  );
}

export function addNotification(userId, data) {
  return createDispatchFunction(
    partial(NotificationsService.addNotification, userId, data),
    addNotificationAction
  );
}

export function setNotificationAsRead(userId, data) {
  return createDispatchFunction(
    partial(NotificationsService.setNotificationAsRead, userId, data),
    setNotificationAsReadAction
  );
}

export function getTemplateparams(userId, data) {
  return createDispatchFunction(
    partial(NotificationsService.getTemplateParams, userId, data),
    getTemplateparamsAction
  );
}
